
import { useState, useEffect } from "react";
import { NavigateFunction } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const useAuthRedirect = (navigate: NavigateFunction) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const {
        data: { session }
      } = await supabase.auth.getSession();
      
      if (session) {
        // Check if user is admin
        const { data: isAdmin } = await supabase.rpc('has_role', {
          role_to_check: 'admin'
        });

        // Redirect authenticated users to the appropriate dashboard
        if (isAdmin) {
          navigate("/admin", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      }
      
      setIsLoading(false);
    };
    
    checkAuth();
  }, [navigate]);

  return { isLoading };
};
